const BASE_URL = `${process.env.VUE_APP_API_DOMAIN}`;
const USER = `${process.env.VUE_APP_API_USER}`;
const DATA = `${process.env.VUE_APP_API_DATA}`;

export {
  BASE_URL,
  USER,
  DATA
}